import { Component, ViewChild, Input } from '@angular/core';

@Component({
    selector: 'carousel',
    templateUrl: './carousel.component.html'
})
export class CarouselComponent
{
    
    @ViewChild('content', { static: true })
    public content: any;

    @Input('css-class')
    public cssClass = '';
    
    slideConfig = {
        "slidesToShow": 3, 
        // "slidesToScroll": 1,
        centerMode: true,
        centerPadding: '-20px',
        arrows: true,
        infinite: false,
        speed: 250,
        initialSlide: 1,
        nextArrow: '<div class="slick-next slick-arrow"><img src="../../../../assets/images/shop-purchase/slider-arrow-next.svg"/></div>',
        prevArrow: '<div class="slick-prev slick-arrow"><img src="../../../../assets/images/shop-purchase/slider-arrow-prev.svg"/></div>',
    };
}
